import { createContext, useContext } from 'react';
import { SHELL_TEXTS, shellLocale, type ShellLocale, type ShellTexts } from './shell-texts';

export const ShellLocaleContext = createContext<ShellLocale | null>(null);

export function browserLanguage(): string {
  return typeof navigator === 'undefined' ? 'da' : navigator.language;
}

/** The chrome's text in the current language (see `ShellLocaleProvider`). */
export function useShellTexts(): ShellTexts {
  const locale = useContext(ShellLocaleContext) ?? shellLocale(browserLanguage());
  return SHELL_TEXTS[locale];
}
